import { Button, Container, Heading, Input, VStack } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { resetPassword } from '../../redux/actions/profile';

const ResetPassword = () => {
  const [password,setPassword] = useState("");
  const params = useParams();
  console.log(params.token);
  
  const dispatch = useDispatch();
  const submitHandler =( e )=> {
    e.preventDefault();
    console.log(params.token);
    dispatch(resetPassword(params.token,password));
  };

  const { loading, message, error } = useSelector(state => state.profile);
  const navigate = useNavigate();
  console.log("Reset : ",params.token);
  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch({ type: 'clearError' });
    }
    if (message) {
      toast.success(message);
      dispatch({ type: 'clearMesssage' });
      navigate('/login');
    }
  }, [dispatch, error, message,navigate]);
  return (
    <Container py={16} h={'90vh'}>
        <form onSubmit={submitHandler}>
        <Heading children="Reset Password" my={16} textTransform={'uppercase'} textAlign={['center',"left"]}></Heading>
        <VStack spacing={8}>
        <Input required id="password" value={password} onChange={(e)=>setPassword(e.target.value)} placeholder='Enter new password' type='password' focusBorderColor='yellow.500'></Input>
        <Button type='submit' w={'full'} colorScheme='yellow' isLoading={loading}>Reset Password</Button>
        </VStack>
        </form>
        
    </Container>
  )
}

export default ResetPassword;